export const reporterV3Url =
  process.env.BUILD_ENV === "local"
    ? "/behavior/v3/risk/user/action_report_3"
    : `https://${process.env.BUILD_ENV !== "prod" ? "test-" : ""}r.akulaku.net/behavior/v3/risk/user/action_report_3`;

/**
 * cookie的键
 */
export const COOKIE_KEYS_MAP = {
  CountryCode: "countryCode",
  CountryId: "countryId",
  LanguageCode: "languageCode",
  LanguageId: "languageId",
};

export const IKI_SLIDER_REPORT_URL = "r.akulaku.net/exception/report/send/slider/log/web";
